<template>
  <v-container>
    <div id="headersMovimentacaoMensal">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto;"
        >
          <table
            style="width: 100%; color: black; border-collapse: collapse;"
            class="elevation-1"
            mobile-breakpoint="0"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="width: 12%; text-align: center;"
                  class="black--text title"
                >
                  Período
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="width: 20%; text-align: center;"
                  class="black--text title"
                >
                  Saldo Inicial
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="width: 20%; text-align: center;"
                  class="black--text title"
                >
                  A Receber
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="width: 20%; text-align: center;"
                  class="black--text title"
                >
                  A Pagar
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="width: 20%; text-align: center;"
                  class="black--text title"
                >
                  Saldo Projeto
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in dadosMovimentacao"
                :key="item.id"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: center;"
                >
                  {{ item.periodo }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                  :style="getColorTable(item.saldo_inicial)"
                >
                  {{ item.saldo_inicial }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                  :style="styleObjectValorReceberClick"
                  @click="onClickReceber(item)"
                >
                  {{ item.receber }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                  :style="styleObjectValorPagarClick"
                  @click="onClickPagamento(item)"
                >
                  {{ item.pagar }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                  :style="getColorTable(item.saldo_projetado)"
                >
                  {{ item.saldo_projetado }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <template>
      <v-dialog
        v-model="dialog.visible"
        transition="dialog-bottom-transition"
        persistent
        max-width="1000px"
        content-class="custom-dialog-content"
        @keydown.esc="dialog.visible = false"
      >
        <v-card>
          <v-card-title>
            <v-spacer />
            <v-icon
              aria-label="Close"
              @click="dialog.visible = false, excluirPagina = true"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-text
            class="text-center"
          >
            <h4>{{ dialog.message }}</h4>
          </v-card-text>
          <v-card-text
            class="pb-3 pt-6 text-center"
            style="white-space: pre-line"
          >
            <div
              id="idTableDetalhe"
              style="overflow-x: auto;"
            >
              <table
                style="width: 100%; color: black; border-collapse: collapse;"
                class="elevation-1"
                mobile-breakpoint="0"
              >
                <thead>
                  <tr>
                    <th
                      v-for="h in headersDetalhe"
                      :key="h.id"
                      style="text-align: center;"
                      class="black--text title"
                    >
                      {{ h.text }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in detalheValores"
                    :key="item.id"
                  >
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: center;"
                    >
                      {{ item.data }}
                    </td>
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: left;"
                    >
                      {{ item.nome }}
                    </td>
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: right;"
                      :style="item.carteira === 'R' ? styleObjectValorReceber : styleObjectValorPagar"
                    >
                      {{ item.valor }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
  import FluxoCaixa from '../../../../../services/fluxocaixa2'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowDadosMovimentacaoFluxoCaixa',
    emits: ['updateMovimentacaoContas'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: '#4CAF50',
      },
      styleProjecaoReceberDias: {
        color: '#7c7673',
      },
      styleObjectValorReceberClick: {
        color: '#4780b8',
        cursor: 'pointer',
      },
      styleObjectValorPagarClick: {
        color: '#f27686',
        cursor: 'pointer',
      },
      styleObjectValorReceber: {
        color: '#4780b8',
      },
      styleObjectValorPagar: {
        color: '#f27686',
      },
      loading: false,
      error: null,
      select: [],
      headersMovimentacao: [
        { text: 'Período', value: 'periodo', width: '10%', align: 'center', class: 'black--text title' },
        { text: 'Saldo Inicial', value: 'saldo_inicial', width: '20%', align: 'right', class: 'black--text title' },
        { text: 'A Receber', value: 'receber', width: '20%', align: 'right', class: 'black--text title' },
        { text: 'A Pagar', value: 'pagar', width: '20%', align: 'right', class: 'black--text title' },
        { text: 'Saldo Projeto', value: 'saldo_projetado', width: '20%', align: 'right', class: 'black--text title' },
      ],
      dadosMovimentacao: [],
      dialog: {
        visible: false,
        message: '',
        valor: 0,
      },
      headersDetalhe: [],
      detalheValores: [],
    }),

    created () {
      eventEmit.$on('update-fluxo', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-fluxo', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (select) {
        this.select = select

        this.showMovimentacao()
      },

      async showMovimentacao () {
        this.loading = true

        this.dadosMovimentacao = []

        await FluxoCaixa.showMovimentacaoMensalFC2(localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.dadosMovimentacao = resposta.data.dadosMovimentacao.map((item) => {
              var listaMovimentacao = ({
                periodo: item.periodo,
                saldo_inicial: item.saldo_inicial ? parseFloat(item.saldo_inicial).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                receber: parseFloat(item.receber).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                pagar: parseFloat(item.pagar).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                saldo_projetado: parseFloat(item.saldo_projetado).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaMovimentacao
            })

            eventEmit.$emit('update-movimentacao-contas', this.dadosMovimentacao)
          } else if (resposta.data.text === 'Usuario nao encontrada') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      getColorTable (value) {
        var negativo = value.substr(0, 1)

        if (negativo === '-') {
          return 'color: #f27686'
        } else {
          return 'color: #4CAF50'
        }
      },

      async onClickReceber (item) {
        this.detalheValores = []

        this.headersDetalhe = [
          { text: 'Data', value: 'data', class: 'black--text title' },
          { text: 'Cliente', value: 'nome', class: 'black--text title' },
          { text: 'Valor', value: 'valor', align: 'right', class: 'black--text title' },
        ]

        if (item.periodo === 'Valores em atraso') {
          await FluxoCaixa.showDadosDelhamentoReceberEmAtraso(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.detalheValores = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  nome: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'R',
                })

                return listaDetalhamento
              })

              this.showDialog('Dados Detalhe Recebimento')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          })
        } else {
          await FluxoCaixa.showDadosDelhamentoData(item.periodo, 'R', localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.detalheValores = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  nome: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'R',
                })

                return listaDetalhamento
              })

              this.showDialog('Dados Detalhe Recebimento')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.detalheValores = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          })
        }
      },

      async onClickPagamento (item) {
        this.detalheValores = []

        this.headersDetalhe = [
          { text: 'Data', value: 'data', class: 'black--text title' },
          { text: 'Fornecedor', value: 'nome', class: 'black--text title' },
          { text: 'Valor', value: 'valor', align: 'right', class: 'black--text title' },
        ]

        if (item.periodo === 'Valores em atraso') {
          await FluxoCaixa.showDadosDelhamentoPagarEmAtraso(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.detalheValores = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  nome: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'P',
                })

                return listaDetalhamento
              })

              this.showDialog('Dados Detalhe Pagamento')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          })
        } else {
          await FluxoCaixa.showDadosDelhamentoData(item.periodo, 'P', localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.detalheValores = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  nome: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'P',
                })

                return listaDetalhamento
              })

              this.showDialog('Dados Detalhe Pagamento')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.detalheValores = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          })
        }
      },

      showDialog (message) {
        this.dialog.visible = true
        this.dialog.message = message
      },
    },
  }
</script>

<style scoped>
  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersMovimentacaoMensal {
      width: 110%;
      margin: -2rem 0 0 0;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    #dadoMovimentacaoDetalhe {
      font-size: 12px;
    }

    #idTable {
      width: 105%;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersMovimentacaoMensal {
      width: 100%;
      margin: -2rem 0 0 0;
    }
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
